import React, {useRef} from 'react';
import Header from '../Header';
import Footer from './Footer';
import useSearchParams from '../../../useSearchParams';

const EmployeeNumberFilter = () => {
  const {query, setQuery} = useSearchParams();
  const refFrom = useRef(null);
  const refTo = useRef(null);

  return (
    <>
      <Header title="従業員数" />
      <div className="p-6 bg-c-bg flex-1 flex flex-col gap-4 rounded-b overflow-y-scroll">
        <div className="bg-white p-6 rounded flex flex-col gap-2">
          <div className="text-c-base font-bold">従業員数</div>
          <div className="flex items-center">
            <input
              min={1}
              type="number"
              defaultValue={query?.employeeNumber?.from}
              onBlur={(e) => {
                const inputValue = e.target.value;
                if (inputValue === '') {
                  const {from, ...restEmployeeNumber} = query.employeeNumber;
                  setQuery({
                    ...query,
                    employeeNumber: {...restEmployeeNumber},
                  });
                } else if (!isNaN(Number(inputValue))) {
                  setQuery({
                    ...query,
                    employeeNumber: {
                      ...query.employeeNumber,
                      from: Number(inputValue),
                    },
                  });
                }
              }}
              ref={refFrom}
              className="form-input w-24 p-2 text-sm"
            />
            <span className="ml-1">人</span>
            <span className="mx-2">~</span>
            <input
              min={1}
              type="number"
              defaultValue={query?.employeeNumber?.to}
              onBlur={(e) => {
                const inputValue = e.target.value;
                if (inputValue === '') {
                  const {to, ...restEmployeeNumber} = query.employeeNumber;
                  setQuery({
                    ...query,
                    employeeNumber: {
                      ...restEmployeeNumber,
                    },
                  });
                } else if (!isNaN(Number(inputValue))) {
                  setQuery({
                    ...query,
                    employeeNumber: {
                      ...query.employeeNumber,
                      to: Number(inputValue),
                    },
                  });
                }
              }}
              ref={refTo}
              className="form-input w-24 p-2 text-sm"
            />
            <span className="ml-1">人</span>
          </div>
        </div>
      </div>
      <Footer
        onClear={() => {
          setQuery({employeeNumber: {}});
          refFrom.current.value = '';
          refTo.current.value = '';
        }}
      />
    </>
  );
};

export default EmployeeNumberFilter;
